<template>
  <div class="p-3 px-4 text-start header-bgnd">
    <h2>
      {{ clientConfig.content.general.modellerName }}
    </h2>
  </div>
</template>

<script>
import clientConfig from '/src/config/client';

export default {
  name: 'HeaderFragment',
  
  data() {
    return {
      clientConfig
    }
  }
}
</script>
